import { LOOP_PRIORITY } from "@/consts/loop";

export default {
  loops: [],
  queryParams: {
    sortBy: "created_at",
    page: 1,
    descending: true,
    rowsPerPage: 15,
    startRow: 0,
    rowsNumber: 0
  },
  loopInteractions: 0,
  loop: {},
  indicators: null
};

export const getLoopDefaultState = () => {
  return {
    interactions: [],
    name: null,
    priority: LOOP_PRIORITY.MEDIUM,
    teams: [],
    auto: false,
    segment_uuid: null,
    message_items: [],
    finish_loop_template_uuid: null,
    sender_name: null,
    send_finish_email: false
  };
};
